import React, { useEffect, useRef, useState } from "react";
import WorldClocks from "./WorldClocks"; // adjust path as needed

const RightSidebarWithClocks = () => {
  const [isOpen, setIsOpen] = useState(false);
  const sidebarRef = useRef(null);
  const toggleButtonRef = useRef(null);

  const toggleSidebar = () => setIsOpen((open) => !open);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        isOpen &&
        sidebarRef.current &&
        toggleButtonRef.current &&
        !sidebarRef.current.contains(event.target) &&
        !toggleButtonRef.current.contains(event.target)
      ) {
        setIsOpen(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [isOpen]);

  return (
    <>
      {/* Toggle button */}
      <button
        aria-label={isOpen ? "Close clocks sidebar" : "Open clocks sidebar"}
        onClick={toggleSidebar}
        className={`toggle-button ${isOpen ? "open" : ""}`}
        ref={toggleButtonRef}
      >
        {/* Door icon SVG */}
        <svg
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          stroke="#444"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
          style={{
            transform: isOpen ? "rotate(180deg)" : "none",
            transition: "transform 0.3s",
          }}
        >
          <polyline points="9 6 15 12 9 18" />
        </svg>
      </button>

      {/* Sidebar */}
      <aside
        className={`right-sidebar ${isOpen ? "open" : ""}`}
        aria-hidden={!isOpen}
        ref={sidebarRef}
      >
        <WorldClocks width={130} height={72} containerHeight={220} />
      </aside>

      <style>{`
        .toggle-button {
          position: fixed;
          top: 80px;
          right: 0;
          background: #fff;
          border: 1px solid #ccc;
          border-right: none;
          border-radius: 4px 0 0 4px;
          padding: 8px;
          cursor: pointer;
          z-index: 1500;
          box-shadow: 0 2px 8px rgba(0,0,0,0.15);
          display: flex;
          align-items: center;
          justify-content: center;
          transition: background-color 0.3s ease;
        }
        .toggle-button:hover {
          background-color: #f0f0f0;
        }
        .right-sidebar {
          position: fixed;
          top: 0;
          right: -280px; /* hidden by default */
          width: 280px;
          height: 100vh;
          background-color: #fff;
          box-shadow: -2px 0 8px rgba(0,0,0,0.1);
          padding-top: 10px;
          overflow-y: auto;
          transition: right 0.3s ease;
          z-index: 1400;
          display: flex;
          flex-direction: column;
          align-items: center;
        }
        .right-sidebar.open {
          right: 0; /* slide in */
        }
        /* Override WorldClocks wrapper to stack vertically */
        .right-sidebar .clocks-wrapper {
          display: flex !important;
          flex-direction: column !important;
          gap: 1.5rem !important;
          padding: 1rem !important;
          padding-left: 0;
          height: auto !important;
          justify-content: flex-start !important;
        }
      `}</style>
    </>
  );
};

export default RightSidebarWithClocks;
